var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.853,
    height: 11.85,
    viewBox: "0 0 10.853 11.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7064",
    "data-name": "Group 7064",
    transform: "translate(-1516.075 -723.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7347",
    "data-name": "Path 7347",
    d: "M1357.75,300.392v.006",
    transform: "translate(167.5 433.998)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7348",
    "data-name": "Path 7348",
    d: "M1357.75,298.558a1.267,1.267,0,0,0,1.22-.936,1.28,1.28,0,0,0-.08-.8,1.263,1.263,0,0,0-.57-.579,1.266,1.266,0,0,0-1.51.295",
    transform: "translate(167.5 433.998)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7349",
    "data-name": "Path 7349",
    d: "M1354.63,290v2.444a.589.589,0,0,0,.18.432.641.641,0,0,0,.44.179h2.5",
    transform: "translate(167.5 433.998)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7350",
    "data-name": "Path 7350",
    d: "M1354.31,301h-4.06a1.251,1.251,0,0,1-.88-.358,1.192,1.192,0,0,1-.37-.865v-8.555a1.19,1.19,0,0,1,.37-.864,1.247,1.247,0,0,1,.88-.358h4.38l3.12,3.055v1.222",
    transform: "translate(167.5 433.998)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestQuote);
export default __webpack_public_path__ + "static/media/request-quote.4d9400f0cd5d170a2abf356ca9228a37.svg";
export { ForwardRef as ReactComponent };